import { GAME_ASSET_SLUG } from "@/config/game";
import { cn } from "@/lib/utils";

type Props = {
  playStyles: number[];
  playStylesPlus?: number[];
  playStylesBonus?: number[];
  playStylesPlusBonus?: number[];
};

/**
 * The card's own PlayStyles first (PlayStyles+ before PlayStyles), then the
 * ones an evolution added, framed so they read as the upgrade.
 */
export const PlayStyles = ({
  playStyles,
  playStylesPlus,
  playStylesBonus,
  playStylesPlusBonus,
}: Props) => {
  const plus = (playStylesPlus ?? []).map((id) => ({
    id,
    plus: true,
    added: !!playStylesPlusBonus?.includes(id),
  }));
  const regular = (playStyles ?? []).map((id) => ({
    id,
    plus: false,
    added: !!playStylesBonus?.includes(id),
  }));
  const all = [...plus, ...regular];
  const ordered = [
    ...all.filter((ps) => !ps.added),
    ...all.filter((ps) => ps.added),
  ];

  return (
    <section className="flex flex-row items-center gap-x-2 pr-2 overflow-x-auto touch-manipulation">
      {ordered.map(({ id, plus: isPlus, added }) => (
        <div
          key={`${isPlus ? "plus" : "base"}-${id}`}
          className={cn(
            "shrink-0",
            added &&
              "bg-evolution border border-evolution-tertiary p-0.5 rounded",
          )}
        >
          <img
            className="w-7 h-7"
            alt={`playstyle${isPlus ? "-plus" : ""}-${id}`}
            src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/${GAME_ASSET_SLUG}/${isPlus ? "playstylesplus" : "playstyles"}/${id}.png`}
          />
        </div>
      ))}
    </section>
  );
};
